import { jsx as r, Fragment as F, jsxs as o } from "react/jsx-runtime";
import { useRef as N, useReducer as U, useCallback as L, useEffect as S } from "react";
import { attributes as k } from "../utils/attributes.js";
import { PrettyBytes as M } from "../utils/bytes.js";
import { Spinner as W } from "../Spinner/Spinner.js";
import { WebFileIcon as q } from "../WebFileIcon/WebFileIcon.js";
import { ButtonIcon as E } from "../ButtonIcon/ButtonIcon.js";
import { SimpleText as X } from "../SimpleText/SimpleText.js";
import { c as C } from "../../createLucideIcon-BC8wu-bu.js";
import { C as G, a as H } from "../../circle-x-CjgDu1_I.js";
/**
 * @license lucide-react v0.441.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const J = C("CircleStop", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["rect", { width: "6", height: "6", x: "9", y: "9", key: "1wrtvo" }]
]);
/**
 * @license lucide-react v0.441.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const K = C("TriangleAlert", [
  [
    "path",
    {
      d: "m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3",
      key: "wmoenq"
    }
  ],
  ["path", { d: "M12 9v4", key: "juzpu7" }],
  ["path", { d: "M12 17h.01", key: "p32p05" }]
]);
function O(e, a) {
  switch (a.type) {
    case "progress": {
      const { loaded: u, total: n } = a;
      return {
        ...e,
        progress: { loaded: u, total: n },
        status: u === n ? "done" : e.status
      };
    }
    case "preview":
      return {
        ...e,
        preview: a.preview
      };
    case "completed":
      return {
        ...e,
        // Just to ensure the file upload is in done status,
        // in case of the onprogress callback function was not called
        status: "done",
        cid: a.cid
      };
    case "cancel":
      return {
        ...e,
        status: "error",
        error: "The upload has been cancelled."
      };
    case "delete":
      return {
        progress: { loaded: 0, total: 0 },
        cid: "",
        preview: "",
        status: "progress",
        error: ""
      };
    case "error":
      return { ...e, error: a.error, status: "error" };
    default:
      return e;
  }
}
const Q = (e) => e.startsWith("image");
function ne({
  file: e,
  onClose: a,
  id: u,
  onSuccess: n,
  codexData: m,
  successMessage: x
  // useWorker,
}) {
  const c = N(null), [h, i] = U(O, {
    progress: { loaded: 0, total: 0 },
    cid: "",
    preview: "",
    status: "progress",
    error: ""
  }), g = L(async () => {
    const { abort: s, result: t } = m.upload(e, I);
    c.current = s;
    const l = await t;
    if (l.error) {
      i({ type: "error", error: l.data.message });
      return;
    }
    i({ type: "completed", cid: l.data }), n == null || n(l.data, e);
  }, [m, n, e]), v = N(!1), I = (s, t) => {
    i({
      type: "progress",
      loaded: s,
      total: t
    });
  };
  S(() => {
    if (!v.current) {
      if (v.current = !0, Q(e.type)) {
        const s = new FileReader();
        s.onload = () => {
          var l;
          const t = (l = s.result) == null ? void 0 : l.toString();
          t && i({ type: "preview", preview: t });
        }, s.readAsDataURL(e);
      }
      g();
    }
  }, [e, g, m]);
  const A = () => {
    var t;
    (t = c.current) == null || t.call(c);
    const s = h.status === "progress" ? "cancel" : "delete";
    i({ type: s });
  }, z = () => {
    var s;
    (s = c.current) == null || s.call(c), a(u);
  }, f = e.name.split("."), b = f.pop(), R = f.join("."), { cid: T, error: w = "", preview: y, progress: d, status: p } = h, j = h.status === "progress" ? A : z, B = d.total > 0 ? d.loaded / d.total * 100 : 0, P = () => /* @__PURE__ */ r(Y, { status: p });
  return /* @__PURE__ */ r(F, { children: /* @__PURE__ */ o("div", { className: "uploadFile", children: [
    /* @__PURE__ */ o("div", { className: "uploadFile-info", children: [
      /* @__PURE__ */ o("div", { className: "uploadFile-infoLeft", children: [
        y ? /* @__PURE__ */ r(
          "img",
          {
            src: y,
            width: "24",
            alt: "Preview",
            className: "uploadFile-preview"
          }
        ) : /* @__PURE__ */ r(q, { type: e.type }),
        /* @__PURE__ */ o("div", { className: "uploadFile-infoText", children: [
          /* @__PURE__ */ o(
            "b",
            {
              className: "uploadFile-name",
              ...k({
                "aria-invalid": p === "error",
                "data-done": p === "done"
              }),
              children: [
                /* @__PURE__ */ r("span", { className: "uploadFile-filename", children: R }),
                /* @__PURE__ */ o("span", { children: [
                  ".",
                  b
                ] })
              ]
            }
          ),
          /* @__PURE__ */ r("div", { children: /* @__PURE__ */ r("small", { children: M(e.size) }) })
        ] })
      ] }),
      /* @__PURE__ */ o("div", { className: "uploadFile-infoRight", children: [
        /* @__PURE__ */ r(V, { status: p }),
        /* @__PURE__ */ r(
          E,
          {
            variant: "small",
            onClick: j,
            Icon: P
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ o("div", { className: "uploadFile-progress", children: [
      /* @__PURE__ */ r(
        "progress",
        {
          className: "uploadFile-progressBar",
          ...k({
            max: e ? d.total.toString() : !1,
            value: e ? d.loaded.toString() : !1,
            "aria-invalid": p === "error"
          })
        }
      ),
      /* @__PURE__ */ o("span", { className: "uploadFile-progressBarPercent", children: [
        B.toFixed(2),
        " %"
      ] })
    ] }),
    /* @__PURE__ */ r("div", { className: "uploadFile-message", children: T ? /* @__PURE__ */ r("div", { className: "text--primary", children: x }) : /* @__PURE__ */ r(X, { variant: "error", children: w || /* @__PURE__ */ r(F, { children: " " }) }) })
  ] }) });
}
function V({ status: e }) {
  switch (e) {
    case "done":
      return /* @__PURE__ */ r(
        G,
        {
          size: "1.25rem",
          fill: "currentColor",
          className: "upload-progress-check",
          stroke: "var(--codex-background)"
        }
      );
    case "error":
      return /* @__PURE__ */ r(
        K,
        {
          size: "1.25rem",
          fill: "currentColor",
          className: "upload-progress-cancelled",
          stroke: "var(--codex-background)"
        }
      );
    case "progress":
      return /* @__PURE__ */ r(W, { width: "1.25rem", className: "upload-progress-check" });
  }
}
function Y({ status: e }) {
  switch (e) {
    case "error":
    case "done":
      return /* @__PURE__ */ r(H, { size: "1.25rem" });
    case "progress":
      return /* @__PURE__ */ r(J, { size: "1.25rem" });
  }
}
export {
  ne as UploadFile,
  V as UploadStatusIcon
};
//# sourceMappingURL=UploadFile.js.map
